import { EntityStatus, FeatureAccessSettings, YammerState, getStatus } from '../../state/types';

type GetFeatureAccessSettings = (state: YammerState) => FeatureAccessSettings | undefined;
export const getFeatureAccessSettings: GetFeatureAccessSettings = (state: YammerState) =>
  state.featureAccessSettings.fulfilled;

type GetFeatureAccessSettingsStatus = (state: YammerState) => EntityStatus;
export const getFeatureAccessSettingsStatus: GetFeatureAccessSettingsStatus = (state) =>
  getStatus(state.featureAccessSettings);
